export const financial = {
	periodLabel: "({{since}} até {{until}})",
	filters: {
		income: "Receita",
		average: "Ticket médio",
		bonus: "Bônus",
	},
	methodFilters: {
		total: "Média",
		zigCredit: "Crédito Zigpay",
		zigDebit: "Débito Zigpay",
		credit: "Crédito",
		debit: "Débito",
		cash: "Dinheiro",
	},
	income: {
		label: "Comparar com",
		labelChart: " Faturado",
	},
	ticket: {
		average: " Ticket Médio",
		real: " Ticket Real",
	},
	bonus: {
		label: " Bônus",
	},
	graphCards: {
		paymentMethod: {
			label: "Métodos de pagamento",
			subtitle:
				"Valor faturado por método de pagamento durante o período {{periodLabel}}",
			zigCredit: "Crédito Zigpay",
			zigDebit: "Débito Zigpay",
			credit: "Crédito",
			debit: "Débito",
			cash: "Dinheiro",
			postEvent: "Após o evento",
			voucher: "Voucher",
			anticipated: "Antecipado",
			dashboard: "Dashboard",
			app: "Aplicativo",
			others: "Outros",
			uniformed: "Não informado",
		},
		billingsPerPeriod: {
			label: "Dias com maiores receitas",
			subtitle: "Valor faturado por dia da semana durante o período {{periodLabel}}",
		},
		averageTicket: {
			label: "Recordes de ticket médio",
			subtitle: "Valor faturado por dia durante o período {{periodLabel}}",
		},
		bonusPerWeek: {
			label: "Dias da semana com mais bônus",
			subtitle: "Valor bonificado por dia durante o período {{periodLabel}}",
		},
		billingsPerWeekDay: {
			label: "Dias da semana com maiores receitas",
			subtitle:
				"Valor médio faturado por dia da semana durante o período {{periodLabel}}",
		},
		averageTicketPerWeekDay: {
			label: "Dias da semana com maiores tickets médios",
			subtitle:
				"Valor médio do Ticket Médio por dia da semana durante o período {{periodLabel}}",
		},
		highestBonus: {
			label: "Maiores bonificações",
			subtitle: "Valor bonificado por dia durante o período {{periodLabel}}",
		},
		consumptionTime: {
			label: "Total de venda por horário",
			subtitle: "Período: {{periodLabel}}",
			filename: "total_de_venda_por_horario",
			formatPeriod: {
				nextPeriod: "{{currPeriod}} até {{nextPeriod}}",
				currPeriod: "às {{currPeriod}}",
			},
			tooltip: {
				dates: "Total consumido de {{since}} até {{until}}:",
				date: "Total consumido às {{date}}",
			},
			columns: {
				period: "Período",
				sunday: "Domingo",
				monday: "Segunda",
				tuesday: "Terça",
				wednesday: "Quarta",
				thursday: "Quinta",
				friday: "Sexta",
				saturday: "Sábado",
				general: "Geral",
			},
		},
	},
	financialChartCards: {
		averageTicket: "Ticket Médio",
		average: " Média",
		billing: "Faturamento",
		bonus: "Bônus",
	},
};
